document.addEventListener("DOMContentLoaded", () => {
  const gallery = document.querySelector("media-gallery");
  if (!gallery) return;

  const featuredImage = gallery.querySelector("[data-featured-media]");
  const viewer = gallery.querySelector('[id^="GalleryViewer"]');
  if (!featuredImage || !viewer) return;

  // Delay until Dawn's built-in JS sets the variant image
  setTimeout(() => {
    const currentActive = viewer.querySelector(".product__media-item.is-active");

    if (currentActive && currentActive !== featuredImage) {
      currentActive.classList.remove("is-active");
      featuredImage.classList.add("is-active");

      // Reset the thumbnail selection as well
      const thumbnails = gallery.querySelectorAll(".thumbnail-list__item");
      thumbnails.forEach((thumb) => {
        thumb.classList.remove("is-active");
        if (thumb.dataset.target === featuredImage.dataset.mediaId) {
          thumb.classList.add("is-active");
        }
      });
    }
  }, 800); // This delay allows variant-image selection to complete first
});